import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ArrowsHorizontal = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.2803 10.44L21.0002 6.71997M21.0002 6.71997L17.2803 3M21.0002 6.71997H3M6.71997 13.54L3 17.26M3 17.26L6.71997 20.98M3 17.26H21",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
